import type { InjectionKey } from 'vue'
import type { AppSettings } from './../../types'

/**
 * Defines the app settings injection key.
 */
export const AppSettingsKey = Symbol() as InjectionKey<AppSettings>
